
@if (field()) {
  <div class="text-field__container">
    
    @if (field().title) {
      <h2 class="ci-heading-h6-semibold">
        {{ field().title }}
      </h2>
    }
    
    @if (field().description) {
      <p class="text-field__description ci-caption-regular">
        {{ field().description }}
      </p>
    }
    
    <ci-text-field-filled
      class="text-field__field"
      [attr.type]="field().type"
      [attr.label]="isTypeEmail() ? ('Email' | translate) : ''"
      [attr.placeholder]="isTypeEmail() ? ('Introduzca su email' | translate) : ''"
      [attr.required]="field().required ? true : null"
      [attr.supporting-text]="field().required ? ('Obligatorio' | translate) : ''"
      [error]="isInvalidField()"
      (input)="handleInput($event)"
    ></ci-text-field-filled>
  </div>
}